import { WhatsAppStatusEnum, ChannelEnum } from '../auth/types/LoginRequest';
import { GetMFAConnectionResponse } from '../auth/types/LoginResponse';
import { CommunicationState } from './types/CommunicationState';

const isWhatsAppable = (data: CommunicationState | GetMFAConnectionResponse): boolean => !!data.phoneNumber
  && data.whatsApp?.enabled && data.whatsApp?.status === WhatsAppStatusEnum.REACHABLE;

export const getAvailableChannels = (data: CommunicationState | GetMFAConnectionResponse): ChannelEnum[] => {
  const channels: ChannelEnum[] = [];
  if (data.phoneNumber) {
    channels.push(ChannelEnum.SMS);
    if (isWhatsAppable(data)) {
      channels.push(ChannelEnum.WHATSAPP);
    }
  }
  if (data.email) {
    channels.push(ChannelEnum.EMAIL);
  }
  return channels;
};

export const getDefaultChannelToSendCode = (data: CommunicationState | GetMFAConnectionResponse, blacklist: ChannelEnum[] = []): ChannelEnum => {
  const channels = getAvailableChannels(data).filter((c) => !blacklist.includes(c));
  if (channels.includes(data.interventionLastMessageChannel)) {
    return data.interventionLastMessageChannel;
  }
  return channels[0];
};

export const getRetryExpiration = (data: CommunicationState | GetMFAConnectionResponse, channel: ChannelEnum) => {
  switch (channel) {
    case ChannelEnum.SMS:
      return data.smsRetryExpiration;
    case ChannelEnum.EMAIL:
      return data.emailRetryExpiration;
    case ChannelEnum.WHATSAPP:
      return data.whatsAppRetryExpiration;
    default:
      console.error('Unknown channel type:', channel satisfies never);
      return undefined;
  }
};

export const formatPhoneNumber = (phoneNumber: string | { prefix: string, local: string } | undefined): string | undefined => {
  if (typeof phoneNumber === 'string') {
    return phoneNumber;
  }
  if (!phoneNumber?.local) {
    return undefined;
  }
  return `+${phoneNumber.prefix} ${phoneNumber.local}`;
};
